"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeAscentis = void 0;
//#endregion
//#region Const
exports.themeAscentis = {
    colors: {
        ascentis: [
            '#BA8A8A',
            '#B77170',
            '#B85554',
            '#B83D3B',
            '#B62928',
            '#B51614',
            '#B70200',
            '#941210',
            '#7A1C1B',
            '#652121',
        ]
    },
    primaryColor: 'ascentis',
    other: {
        mainBackgroundColor: "#e6e6e6"
    },
};
//#endregion
//# sourceMappingURL=themeAscentis.js.map